import { base44 } from '@/api/base44Client';
import { withRateLimitRetry } from '@/lib/rateLimitRetry';

/**
 * Rebuilds the HomeCache entity from the source entities.
 * Call this after any admin save to BroadcastNotification, HeroSection, HomeLinks, or ContactInfo.
 */
export async function rebuildHomeCache() {
  const [broadcasts, heroData, links, contactData] = await Promise.all([
    withRateLimitRetry(() => base44.entities.BroadcastNotification.filter({ is_active: true })),
    withRateLimitRetry(() => base44.entities.HeroSection.list()),
    withRateLimitRetry(() => base44.entities.HomeLinks.list()),
    withRateLimitRetry(() => base44.entities.ContactInfo.list())
  ]);

  const sorted = broadcasts.sort((a, b) => {
    const orderA = a.display_order !== undefined ? a.display_order : Infinity;
    const orderB = b.display_order !== undefined ? b.display_order : Infinity;
    return orderA - orderB;
  });

  const payload = {
    broadcasts: sorted,
    hero: heroData[0] || null,
    home_links: links.filter((l) => l.is_enabled),
    contact_info: contactData[0] || null,
    last_updated: new Date().toISOString()
  };

  const existing = await base44.entities.HomeCache.list();
  if (existing.length > 0) {
    await base44.entities.HomeCache.update(existing[0].id, payload);
  } else {
    await base44.entities.HomeCache.create(payload);
  }
}